import Vue from 'vue';
import { errorHandler } from '../../../helpers/helpers';
import NOTICIA_MAIS_RECENTES from '../../../graphql/revista/queries/NoticiaMaisRecentes.gql';
import * as types from '../../types/barra-lateral.types';
import env from '../../../config/env';

export default {
  namespaced: true,
  state: {
    carregando: {
      recentes: true,
      lidas: true,
    },
    recentes: [],
    lidas: [],
  },
  getters: {
    carregando: state => state.carregando,
    getRecentes: state => state.recentes,
    getLidas: state => state.lidas,
  },
  mutations: {
    [types.RECENTES](state, payload) {
      state.recentes = payload;
      state.carregando.recentes = false;
    },
    [types.LIDAS](state, payload) {
      state.lidas = payload;
      state.carregando.lidas = false;
    },
  },
  actions: {
    recentes({ commit, state, rootGetters }) {
      state.recentes = [];
      state.carregando.recentes = true;
      setTimeout(() => {
        const uf = rootGetters['user/uf'];
        if (uf) {
          env.apolloRevista
            .query({
              query: NOTICIA_MAIS_RECENTES,
              variables: {
                modulo: env.revista.modulo,
                canal: rootGetters['home/canal'],
                uf: [uf],
                paginate: 5,
              },
            })
            .then(
              ({ data: { noticias } }) => {
                commit(types.RECENTES, noticias.data);
              },
              err => errorHandler(err),
            );
        }
      }, 300);
    },
    lidas({ commit, state, rootGetters }) {
      state.lidas = [];
      state.carregando.lidas = true;
      const uf = rootGetters['user/uf'];
      Vue.http
        .get(
          `${process.env.VUE_APP_API_URL}/revista-online/noticia/${uf}?include=categoria&limit=5&modulo=revista`,
        )
        .then(
          ({ data: { data } }) => {
            commit(types.LIDAS, data);
          },
          err => errorHandler(err),
        );
    },
  },
};
